import {createBrowserHistory} from 'history';
// ** Create Browser History.
const history = createBrowserHistory();
export default history;
